var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"flag-icon",attrs:{"src":`/static/img/flags/${_vm.country}.svg`}})
}
var staticRenderFns = []

export { render, staticRenderFns }